export default {
	section_banner: {
		title: {
			one: '受け取る',
		},
		main_title: {
			one: '預金',
		},
		paragraph: {
			one: 'JPWorldPayで便利に入金を受け取れます。友人、顧客、ビジネスパートナーからの支払いなど、JPWorldPayなら迅速かつ安全に資金を受け取ることができます。',
		},
		cta_buttons: {
			one: 'Send Asset',
			two: 'Download App',
		},
	},

	seller_access: {
		label: '手間のかからない方法',
		title: {
			one: '一番',
			two: '便利',
			three: 'デポジット',
		},
		paragraph: {
			one: '相手のメールアドレスに送信するだけで完了です。JPWorldPayなら、メールアドレスを共有するだけで簡単に送金できます。複雑な手順や口座情報は必要ありません。いつでも、迅速かつ安全に、手間なく送金できます。',
			two: 'JPWorldPayを使えば、送金は日々のルーティンにシームレスに溶け込みます。友人への返済、ギフトの送付、個人的な取引など、必要なのはメール1通だけです。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},

	deposit_recipients: {
		label: '入金通知',
		title: {
			one: '何が',
			two: '受信者が見る',
		},
		paragraph: {
			one: 'JPWorldPayでは、受取人は送金の明確な通知に加え、送金者の名前、金額、日付、取引目的などの詳細情報を確認できます。インターフェースはユーザーフレンドリーで、受け取った資金を即座に安全に追跡・管理できます。',
		},
	},

	credit_system_sec: {
		label: '最速の支払いシステム',
		title: {
			one: '間の転送 ',
			two: 'テザー',
			three: '&',
			four: 'ジガ',
		},
		paragraph: {
			one: 'JPWorldPaysのシームレスな交換システムを使えば、TetherとZIGA間で簡単に資金を送金できます。USDTからUSOTへ、あるいはその逆の場合でも、手続きは迅速、安全、そして手間いらずです。リアルタイム送金、最小限の手数料、そしてすべてのステップにおける完全な透明性をお楽しみください。',
		},
		cta_buttons: '始めましょう',
	},
	credit_system_right_sec: {
		label: '最速の支払いシステム',
		title: {
			one: '素早い',
			two: '&',
			three: '簡単',
			four: 'セットアッププロセス',
		},
		paragraph: {
			one: 'お友達がJPWorldPayアカウントをお持ちでない場合は、サインアップするだけで数分で完了します。手続きはシンプルで迅速、すぐに送金や受け取りができるようになります。安全で便利な取引をすぐに開始できます。',
		},
		cta_buttons: '始めましょう',
	},

	question_sec: {
		label: '給与プロセス',
		title: {
			one: '簡単です',
			two: '給料を送りますか？',
		},
		paragraph: {
			one: 'アプリを開いて「支払いを受け取る」を選択すると、QRコードが生成され、支払い情報が即座に共有されるため、他のユーザーが安全に簡単に送金できるようになります。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},
	received_request_sec: {
		label: 'JPWorldPayユーザーを選択',
		title: {
			one: '入力 ',
			two: '要求されたもの ',
			three: '額',
		},
		paragraph: {
			one: 'JPWorldPayを通して資産リクエスト用のリンクを瞬時に作成することで、日々の暗号通貨の受け取りを簡素化できます。この合理化されたプロセスにより、迅速かつ安全に支払いを受け取り、取引の管理が容易になります。常に財務状況を把握し、シームレスな送金をお楽しみください。JPWorldPayを使えば、暗号通貨の管理はかつてないほど簡単になります。',
			two: 'JPWorldPayでは、すべての取引をリアルタイムで追跡できるため、財務活動を完全に可視化できます。送金時も受取時も、資金の所在を常に正確に把握できます。さらに、強化されたセキュリティ機能により、お客様の情報はプライバシーが保護され、あらゆる取引において安心感が得られます。JPWorldPayは詳細な取引履歴も提供しているため、過去の支払いの確認や支出の追跡も簡単です。',
		},
		cta_buttons: {
			one: 'JPWORLDPAY LINKの作成',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
